export default "__VITE_ASSET__s4rPNZrh__"